/* 🤖 this file was generated by svg-to-ts */
export const iconDcentwallet: {
  name: 'dcentwallet';
  data: string;
} = {
  name: 'dcentwallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m.33 1.89 2.1 1.21V6l-2.1 1.21V1.88zm2.01 9.85v5.69l-4.82 2.79v-5.69zM3.62 22.67V9.23c0-.25.13-.49.36-.62l11.64-6.72v5.74l-7.03 4.05v8.16l-4.97 2.87zm24.35.62-11.64 6.72c-.22.13-.49.13-.71 0l-11.61-6.7 4.97-2.87 6.99 4.04L23 20.42l4.98 2.87zm-4.61-3.5v-5.22l-4.96-2.86 4.96-2.86v-2.9l4.61 2.66c.22.13.35.36.36.62v13.43z"/></svg>`,
};
